<script>
import {generateSimpleImageMapFor} from "@homepage/helpers/image";

export default {
	name: "WinningNumbersSidebar",
	props: {
		open: {
			type: Boolean,
			required: true
		},
		results: {
			type: Array,
			required: true
		}
	},
	components: {
		Digit: () => import("@homepage/components/DigitImageDisplay.vue"),
	},
	watch: {
		open() {
			if (this.open) {
				document.querySelector('html').style.overflow = 'hidden';
			} else {
				document.querySelector('html').style.overflow = 'auto';
				this.$nextTick(() => {
					document.querySelector('.results-sidebar').scrollTop = 0;
				})
			}
		}
	},
	provide() {
		return {
			imagesMap: generateSimpleImageMapFor('quickmoney'),
		};
	},
}
</script>

<template>
	<div>
		<div id="body-overlay" @click="$emit('update:open', false)" :class="{ open: open }"></div>
		<nav class="results-sidebar" :class="{ open: open }" role="navigation">
			<v-btn id="close-btn" block color="primary" @click="$emit('update:open', false)">Close</v-btn>
			<v-container v-for="{result, sortition} in results" :key="`${sortition.id}-${result.date}`">
				<v-row justify="center" no-gutters>
					<v-col cols="auto">
						<v-img width="100" height="100" :src="sortition.logo.url" contain></v-img>
					</v-col>
				</v-row>
				<v-row class="mt-0" justify="center">
					<v-col cols="auto">
						<h4 class="text-center">
							<font-awesome-icon icon="calendar"></font-awesome-icon>
							{{ result.date }}
						</h4>
					</v-col>
				</v-row>
				<v-row v-if="result.first" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						1st
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.first"></digit>
					</v-col>
				</v-row>
				<v-row v-if="result.second" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						2nd
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.second"></digit>
					</v-col>
				</v-row>
				<v-row v-if="result.third" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						3rd
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.third"></digit>
					</v-col>
				</v-row>
				<v-row v-if="result.cashThree" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						Cash 3
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.cashThree"></digit>
					</v-col>
				</v-row>
				<v-row v-if="result.pickFour" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						Pick 4
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.pickFour"></digit>
					</v-col>
				</v-row>
				<v-row v-if="result.pickFive" no-gutters class="mt-0" justify="center" align="center">
					<v-col cols="auto" class="font-weight-bold mr-2">
						Pick 5
					</v-col>
					<v-col cols="auto">
						<digit :digit="result.pickFive"></digit>
					</v-col>
				</v-row>
				<v-divider class="mt-5"></v-divider>
			</v-container>
			<v-container v-if="results.length === 0">
				<v-row justify="center">
					<v-col cols="auto">
						<h4 class="text-center">No results for today.</h4>
					</v-col>
				</v-row>
			</v-container>
		</nav>
	</div>
</template>

<style scoped lang="scss">
* {
	color: black;
}

#close-btn {
	position: sticky;
	top: 0;
	z-index: 10;
}

#body-overlay {
	width: 100vw;
	height: 100vh;
	display: none;
	position: fixed;
	z-index: 3;
	top: 0;
	overflow: hidden;
	background: rgba(0, 0, 0, 0.5);

	&.open {
		display: block;
	}
}


// Menu

.results-sidebar {
	overflow-y: auto;
	position: fixed;
	top: 0;
	left: -300px;
	z-index: 5;
	width: 300px;
	height: 100%;
	padding: .5rem 1rem;
	box-shadow: 0 6px 12px rgba(107, 82, 82, 0.3);
	background-color: white;
	box-sizing: border-box;
	transition: ease left 0.2s;

	&.open {
		left: 0;
	}
}

</style>
